import React from "react";
import FavoriteMedicationItemRowItem from "./favoriteMedicationItem_rowItem";


type FavoriteMedicationItemRowProps = {
  item?: any
  pushFavoriteMedicationItem: any
}


const FavoriteMedicationItemRow = ({
 item,
 pushFavoriteMedicationItem
}: FavoriteMedicationItemRowProps) => {

  // Function to handle changes in body checkboxes
  const handleBodyCheckboxChange = (checked: boolean, item: any) => {
    pushFavoriteMedicationItem(item, checked)
  };

  return (
    <div className=" ">
      <div className="form-group">
        <FavoriteMedicationItemRowItem
          key={item.id}
          item={item}
          onChange={handleBodyCheckboxChange}
        />
      </div>
    </div>
  );
};


export default FavoriteMedicationItemRow